import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recipe-part-view',
  templateUrl: './recipe-part-view.component.html',
  styleUrls: ['./recipe-part-view.component.css']
})
export class RecipePartViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
